import { type FC } from 'react'

import { ErxBonusLandingPageFaq } from './components/ErxBonusLandingPageFaq/ErxBonusLandingPageFaq'
import { ErxBonusLandingPageHeroHeader } from './components/ErxBonusLandingPageHeroHeader/ErxBonusLandingPageHeroHeader'
import { ErxBonusLandingPageHowBonusIsCalculated } from './components/ErxBonusLandingPageHowBonusIsCalculated/ErxBonusLandingPageHowBonusIsCalculated'
import { ErxBonusLandingPageMarketingBanner } from './components/ErxBonusLandingPageMarketingBanner/ErxBonusLandingPageMarketingBanner'
import { ErxBonusLandingPageTypesOfPrescriptions } from './components/ErxBonusLandingPageTypesOfPrescriptions/ErxBonusLandingPageTypesOfPrescriptions'

export const ErxBonusLp: FC = () => {
  return (
    <>
      <ErxBonusLandingPageHeroHeader />
      <div className="bg-light-primary-medium">
        <div className="container px-4">
          <ErxBonusLandingPageHowBonusIsCalculated />
          <ErxBonusLandingPageMarketingBanner />
          <ErxBonusLandingPageTypesOfPrescriptions />
          <ErxBonusLandingPageFaq />
        </div>
      </div>
    </>
  )
}
